import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AgentsService} from "../../services/agents-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";
import {ScheduleType} from "../../../schedule/types/schedule.type";
import {AgentScheduleExtraDataRequestType} from "../../../schedule/types/agent-schedule-extra-data-request.type";
import {AgentScheduleExtraDataRequestModel} from "../../../schedule/models/agent-schedule-extra-data-request.model";
import {AbsenceReasonSettings} from "../../../site-preferences/models/absence-reason-settings.model";

export class AgentScheduleViewCtrl implements IController {

  agent: AgentModel;
  from: any;
  to: any;
  selectedTemplate: any;
  absenceReasons: AbsenceReasonSettings[];

  public shifts: any;
  private userZoneId: string;
  private dateFormat: any;
  private columnFormat: any;

  private views: any;
  private canCreate: boolean;
  private canUpdate: boolean;
  private canDelete: boolean;
  private events: any;


  public approvalSchedules: any;
  public approvalSchedulesTypes: ScheduleType[] = [ScheduleType.Availability, ScheduleType.Leave];
  public approvalSchedulesTypesOptions: ScheduleType[] = [ScheduleType.Availability, ScheduleType.Leave];
  public isShowLeaveTable: boolean = false;
  public selectedShift: any;
  public selectedShiftDate: any;
  public isEditShiftEnabled: any;
  public selectedShiftTemplate: any;

  constructor(private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService, private splitService: SplitService, private $q: IQService, private commonsService: CommonsService,
              private commonsDialogService: CommonsDialogService, private IAMPermissions, private $log, private scheduleService: ScheduleService,
              private agentsService: AgentsService, private moment, private $filter) {
  }

  $onInit() {
    this.userZoneId = this.splitService.getTimeZone();
    this.dateFormat = this.splitService.getDateAndTimeConfig().long;
    this.columnFormat = 'ddd ' + this.dateFormat;

    // ctrl.dateFormat = splitService.getDateAndTimeConfig().long;
    // ctrl.firstDay = splitService.getDateAndTimeConfig().firstDay;
    this.views = ['agendaWeek', 'agendaDay'];

    this.canCreate = this.IAMPermissions.hasPermission('schedule.service.create');
    this.canUpdate = this.IAMPermissions.hasPermission('schedule.service.update');
    this.canDelete = this.IAMPermissions.hasPermission('schedule.service.delete');

    if (!this.shifts) {
      this.shifts = [];
    }
  }

  onSelectScheduleTemplate($event) {
    this.scheduleDialogService.selectTemplate($event, this.selectedTemplate)
      .then((template) => {
        this._updateAgentScheduleByTemplate(template);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onApprovalSchedulesTypesChange(approvalSchedulesTypes: ScheduleType[]) {
    this.approvalSchedulesTypes = approvalSchedulesTypes;
    this._setApprovalSchedules(this.shifts, approvalSchedulesTypes);
  }

  onRemoveTemplate() {
    this._updateAgentScheduleByTemplate();
  }


  onClearSchedule($event) {
    this.confirmDialogService.confirm('Reset Schedule', 'Are you sure you want to reset this schedule?', $event)
      .then(() => {
        this._clearAgentSchedule();
      })
  }

  onToggleLeaveTable() {
    this.isShowLeaveTable = !this.isShowLeaveTable;
  }

  onCreateSchedule($event, from, to) {
    const userName = this.$filter('userName')(this.agent.user);
    const formattedDate = from ? this.$filter('bringozFullDate')({notAfter: from}, 'notAfter') : '';
    const name = [userName, formattedDate].filter(part => part).join(' ');

    if (!from && !to) {
      from =  this.moment().startOf('day').valueOf();
      to = this.moment().endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
    }

    const selectedShift = {
      agentSchedule: {
        name: name || '',
        type: ScheduleType.Availability,
        schedule: {
          startTime: from,
          endTime: to
        }
      }
    }
    this.onShiftSelect(selectedShift, from, true);
    // const zoneId = this.agent.zoneId || _.get(this.selectedTemplate, 'zoneId', this.userZoneId);
    // this.scheduleDialogService.create($event, from, to, zoneId)
    //   .then((scheduleToCreate) => {
    //     this._createSchedule(scheduleToCreate);
    //   })
    //   .catch(() => {
    //     this.$log.info('Dialog Closed');
    //   });
  }

  onShiftSelect(shift, date, isEdit?) {
    this.selectedShift = shift;
    this.selectedShiftDate = date;
    this.isEditShiftEnabled = isEdit || false;
    this.selectedShiftTemplate = undefined;

    if (!!shift?.agentSchedule?.templateId && !shift?.agentSchedule?.template && !shift?.agentSchedule?.overridden) {
      this._getShiftTemplate(shift.agentSchedule.templateId, this.agent.id);
    }
  }

  onEditShift(enabled) {
    this.isEditShiftEnabled = enabled;
  }

  onAddNoteToShift($event, extraDataItem?) {
    this.scheduleDialogService.addNote($event, _.get(extraDataItem, 'internalNote'))
      .then((internalNote) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

        if (!extraDataItem) {
          extraDataItem = {};
        }

        const extraDataItemCopy = angular.copy(extraDataItem);
        extraDataItemCopy.internalNote = internalNote;
        const scheduleExtraDataPayload = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy
        }
        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onEditBreakToShift($event, extraDataItem, breakIndex) {
    var day = this.moment(this.selectedShiftDate).date(),
      month = this.moment(this.selectedShiftDate).month(),
      year = this.moment(this.selectedShiftDate).year();

    const minStartTime = this.moment(this.selectedShift.agentSchedule.schedule.startTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const minEndTime = this.moment(this.selectedShift.agentSchedule.schedule.endTime).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    const isRecurring = !!this.selectedShift?.agentSchedule?.templateId && !this.selectedShift.agentSchedule.template && !this.selectedShift.agentSchedule.overridden;
    this.scheduleDialogService.updateShiftBreak($event, extraDataItem.breaks[breakIndex], isRecurring, minStartTime, minEndTime)
      .then((payload: {
        break: any,
        type: AgentScheduleExtraDataRequestType,
        repeatFrom?: string,
        repeatTo?: string
      }) => {
        const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
        const agentId = _.get(this.selectedShift, 'agentId');
        const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');


        const extraDataItemCopy = angular.copy(extraDataItem);

        extraDataItemCopy.breaks[breakIndex] = payload.break;

        const scheduleExtraDataPayload: AgentScheduleExtraDataRequestModel = {
          scheduleId: scheduleId,
          agentId: agentId,
          eventDate: this.selectedShiftDate,
          extraData: extraDataItemCopy,
          type: payload.type,
        }

        if (payload.repeatFrom && payload.repeatTo) {
          scheduleExtraDataPayload.repeatFrom = payload.repeatFrom;
          scheduleExtraDataPayload.repeatTo = payload.repeatTo;
        }

        this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
      })
  }

  onRemoveBreakFromShift($event, extraDataItem, breakIndex) {
    let extraDataItemCopy = angular.copy(extraDataItem);
    // if (!extraDataItemCopy) {
    //   extraDataItemCopy = {};
    // } else {
    //   _.unset(extraDataItemCopy, 'breaks');
    // }

    extraDataItemCopy.breaks.splice(breakIndex, 1);

    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onRemoveNoteFromShift($event, extraDataItem?) {
    const scheduleId = _.get(this.selectedShift, 'agentSchedule.id');
    const agentId = _.get(this.selectedShift, 'agentId');
    const zoneId = _.get(this.selectedShift, 'agentSchedule.schedule.timezone');

    const extraDataItemCopy = angular.copy(extraDataItem);
    extraDataItemCopy.internalNote = undefined;
    const scheduleExtraDataPayload = {
      scheduleId: scheduleId,
      agentId: agentId,
      eventDate: this.selectedShiftDate,
      extraData: extraDataItemCopy
    }
    this._onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId);
  }

  onUpdateShift(shift, updateSpecificDay) {
    const type = (!!updateSpecificDay || _.isUndefined(updateSpecificDay)) ? 'EVENT' : 'FUTURE';
    this._updateOneSchedule(shift, type);
  }

  onCreateShift(shift, weekDays) {

    if (!!weekDays) {
      const shifts = _.map(weekDays, (wd) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule.schedule.byWeekDay = [wd];
        return shiftCopy;
      })
      this._createMultipleSchedule(shifts);
    } else {
      this._createSchedule(shift);
    }
  }











  onEditSchedule(scheduleEvent, needToEdit, revertFunc, $event) {
    let eventInstanceFromDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const isRecurring = !!scheduleRef.schedule.templateId && !scheduleRef.schedule.template && !scheduleRef.schedule.overridden;
    // var functionRef = scheduleRef.schedule.freq ? scheduleDialogService.selectChangeType($event) : $q.when()
    const functionRef = (scheduleRef.holderType === 'AGENT' && !!isRecurring) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when()

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        let eventInstanceToDate;
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceFromDate = this.moment(scheduleEvent.start.toISOString()).valueOf();
          eventInstanceToDate = this.moment(scheduleEvent.end.toISOString()).valueOf();
          // eventInstanceFromDate = scheduleEvent.start.valueOf();
          // eventInstanceToDate = scheduleEvent.end.valueOf();
        }

        return needToEdit ? this.scheduleDialogService.edit($event, scheduleRef, eventInstanceFromDate, eventInstanceToDate) : this.$q.when({schedule: scheduleRef});
      })
      .then((editedSchedule) => {
        const shift = _.find(this.shifts, (s) => {
          return s.instanceId === scheduleEvent.dataRef.id;
        })
        if (!!shift) {
          shift.agentSchedule = editedSchedule.schedule;
          this._updateOneSchedule(shift, changeType);
        }
      })
      .catch((error) => {
        if (revertFunc) {
          revertFunc();
        }
        this.$log.info('Dialog Closed');
      });
  }

  onDeleteSchedule(scheduleEvent, $event) {
    let eventInstanceDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const isRecurring = !!scheduleRef.schedule.templateId && !scheduleRef.schedule.template && !scheduleRef.schedule.overridden;

    const functionRef = (scheduleRef.holderType === 'AGENT' && !!isRecurring) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = scheduleEvent.start.valueOf();
        }

        // if (changeType === 'ALL') {
        //     eventInstanceDate = scheduleRef.schedule.startTime;
        // }

        this._deleteSchedule(scheduleRef.id, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onViewRender(start, end) {
    const currentStart = start.valueOf();
    const currentEnd = end.valueOf();

    if (this.from !== currentStart || this.to !== currentEnd) {
      this.from = currentStart;
      this.to = currentEnd;

      this._initAgentSchedule(currentStart, currentEnd)
    }
  }

  onCalendarSelection(from, to, $event) {
    // If only clicked on calendar (less then an full hour)
    if (to.valueOf() - from.valueOf() <= 1800000) {
      return;
    }

    let toTimestamp: number;
    let fromTimestamp: number = from.valueOf();

    if (this.moment(to.valueOf()).get('hour') === 0) {
      toTimestamp = to.valueOf() - 900000;
    } else {
      toTimestamp = to.valueOf();
    }

    this.onCreateSchedule($event, fromTimestamp, toTimestamp);
  }

  onEventClick(event, $event) {

    if (this.moment(event.start).startOf('day').isBefore(this.moment().startOf('day'))) {
      return;
    }

    const actions = _.chain([
      {key: 'Edit', value: this.canUpdate},
      {key: 'Delete', value: this.canDelete}
    ])
      .filter((a) => {
        return a.value;
      })
      .map((a) => {
        return a.key
      })
      .value();

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Edit') {
          const shift = _.find(this.shifts, (s) => {
            return s.instanceId === event.dataRef.id;
          })
          const selectedShift = angular.copy(shift);
          const selectedShiftDate = this.moment(event.start).valueOf();

          this.onShiftSelect(selectedShift, selectedShiftDate, true);
          // this.onEditSchedule(event, true, undefined, $event)
        }
        if (reason === 'Delete') {
          this.onDeleteSchedule(event, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onEventChange(event, delta, revertFunc, $event) {

    const oneScheduleCopy = angular.copy(event);

    if (oneScheduleCopy.start.startOf('day').isBefore(this.moment().startOf('day'))) {
      revertFunc();
      return;
    }

    oneScheduleCopy.dataRef.schedule.startTime = this.moment(event.start.toISOString()).valueOf();
    oneScheduleCopy.dataRef.schedule.endTime = this.moment(event.end.toISOString()).valueOf();
    // oneScheduleCopy.dataRef.schedule.startTime = event.start.valueOf();
    // oneScheduleCopy.dataRef.schedule.endTime = event.end.valueOf();

    this.onEditSchedule(oneScheduleCopy, false, revertFunc, $event);
  }

  getHeight() {
    // var element = angular.element(document.querySelector('#content-container'));
    // return element[0].clientHeight;
  }

  onApproveSchedule(shift: any, from: string, to: string) {
    const payload = [
      {id: shift.agentSchedule.id, from: from, to: to}
    ];
    this.scheduleService.approveSchedule(payload)
      .then((approvedSchedules) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule = approvedSchedules[0];

        const approvalScheduleIndex = this.approvalSchedules.findIndex((s) => {
          return s.id === shift.id;
        })
        this.approvalSchedules[approvalScheduleIndex] = shiftCopy;

        const scheduleIndex = this.shifts.findIndex((s) => {
          return s.id === shift.id;
        })
        const schedulesCopy = angular.copy(this.shifts);
        schedulesCopy[scheduleIndex] = shiftCopy;
        this.shifts = schedulesCopy;

        this.events = this._convertShiftsToScheduleEvents(this.shifts);
      })
  }

  onRejectSchedule(shift: any) {
    const payload = [shift.agentSchedule.id];
    this.scheduleService.rejectSchedule(payload)
      .then((rejectedSchedules) => {
        const shiftCopy = angular.copy(shift);
        shiftCopy.agentSchedule = rejectedSchedules[0];

        const approvalScheduleIndex = this.approvalSchedules.findIndex((s) => {
          return s.id === shift.id;
        })
        this.approvalSchedules[approvalScheduleIndex] = shiftCopy;

        const scheduleIndex = this.shifts.findIndex((s) => {
          return s.id === shift.id;
        })
        const schedulesCopy = angular.copy(this.shifts);
        schedulesCopy[scheduleIndex] = shiftCopy;
        this.shifts = schedulesCopy;

        this.events = this._convertShiftsToScheduleEvents(this.shifts);
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _initAgentSchedule(from, to) {
    const scheduleTypes = [ScheduleType.Shift, ScheduleType.Availability, ScheduleType.Leave];
    this.scheduleService.getByAgentIds([this.agent.id], from, to, scheduleTypes, [], false)
      .then((shifts: any[]) => {
        this.shifts = shifts;
        this.events = this._convertShiftsToScheduleEvents(shifts);

        this._setApprovalSchedules(this.shifts, this.approvalSchedulesTypes);
      })
  }

  private _setApprovalSchedules(schedules, types: ScheduleType[]) {
    this.approvalSchedules = schedules.filter((s) => {
      return _.includes(types, s.agentSchedule.type);
    });
  }

  private _updateAgentScheduleByTemplate(template?) {
    this.agentsService.selectScheduleTemplate(this.agent.id, _.get(template, 'id'))
      .then((updatedTemplate) => {
        this.selectedTemplate = template;
        this._initAgentSchedule(this.from, this.to);
      })
  }

  private _createSchedule(schedule) {
    if (schedule) {

      const agentSchedule = angular.copy(schedule.agentSchedule);
      agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();
      agentSchedule.schedule.interval = agentSchedule.schedule.interval || 1;
      this.scheduleService.createManyByAgentId([agentSchedule], this.agent.id)
        .then((createdSchedules: any[]) => {
          this.onShiftUnSelect();
          this._initAgentSchedule(this.from, this.to);
        })
        .catch((error) => {
          this.scheduleDialogService.handleConflictError(error, this.agent.id, [agentSchedule])
            .then((created) => {
              if (created) {
                this.onShiftUnSelect();
                this._initAgentSchedule(this.from, this.to);
              }
            });
        });
    }
  }

  private _updateOneSchedule(shift, type) {
    this.scheduleService.updateOneByAgentId(shift.agentSchedule, shift.agentSchedule.id, shift.agentId, type, shift.agentSchedule.schedule.startTime)
      .then((updatedSchedule) => {
        this.onShiftUnSelect();
        this._initAgentSchedule(this.from, this.to);
      })
      .catch((error) => {
        this.scheduleDialogService.handleConflictError(error, this.agent.id);
      });
  }


  private _deleteSchedule(scheduleId, type, eventInstanceDate) {
    this.scheduleService.deleteOneByAgentId(scheduleId, this.agent.id, type, eventInstanceDate)
      .then((deletedShift) => {
        this._initAgentSchedule(this.from, this.to);
      })
  }

  private _clearAgentSchedule() {
    return this.agentsService.clearSchedule(this.agent.id)
      .then(() => {
        this.shifts = [];
        this.events = [];
        this.selectedTemplate = undefined;
      })
  }

  private _convertShiftsToScheduleEvents(shifts) {

    if (!shifts) {
      return [];
    }

    const schedules = _.flatMap(shifts, 'agentSchedule');
    return this.scheduleService.parseManyScheduleToEventsByRange(schedules, this.from, this.to, this.agent.id, this.agent.zoneId);
  }

  private _getShiftTemplate(templateId: string, agentId: string) {
    this.scheduleService.getOneByAgentId(templateId, agentId)
      .then((template) => {
        if (!!this.selectedShift) {
          this.selectedShiftTemplate = template;
        }
      })
  }

  private _onUpdateExtraDataItem(scheduleExtraDataPayload, zoneId) {
    this.scheduleService.updateScheduleExtraData([scheduleExtraDataPayload], zoneId)
      .then((updatedExtraDataItems) => {

        const shiftRef = _.find(this.events, (s) => {
          return s.id === this.selectedShift.id;
        })

        if (!shiftRef.scheduleExtraData) {
          shiftRef.scheduleExtraData = [];
        }

        shiftRef.scheduleExtraData = _.uniqBy(_.concat(updatedExtraDataItems, shiftRef.scheduleExtraData), 'id');
        shiftRef.agentSchedule.updatedAt = this.moment().valueOf();
        this.events = angular.copy(this.events);

        this.selectedShift = angular.copy(shiftRef);
        this.isEditShiftEnabled = false;
      })
  }

  private _createMultipleSchedule(shifts) {
    if (shifts.length) {

      const agentSchedulesList = [];

      _.forEach(shifts, (s) => {
        const agentSchedule = angular.copy(s.agentSchedule);
        agentSchedule.schedule.zoneIdName = this.splitService.getTimeZone();
        agentSchedule.schedule.interval = agentSchedule.schedule.interval || 1;
        agentSchedulesList.push(agentSchedule);
      })

      this.scheduleService.createManyByAgentId(agentSchedulesList, this.agent.id)
        .then((createdSchedules) => {
          this.onShiftUnSelect();
          this._initAgentSchedule(this.from, this.to);
        })
        .catch((error) => {
          this.scheduleDialogService.handleConflictError(error, this.agent.id, agentSchedulesList)
            .then((created) => {
              if (created) {
                this.onShiftUnSelect();
                this._initAgentSchedule(this.from, this.to);
              }
            });
        });
    }
  }

  onShiftUnSelect() {
    this.selectedShift = undefined;
    this.selectedShiftTemplate = undefined;
    this.selectedShiftDate = undefined;
    this.isEditShiftEnabled = false;
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentScheduleView', {
    bindings: {
      agent: '<',
      from: '<',
      to: '<',
      selectedTemplate: '<?',
      absenceReasons: '<?'
    },
    template: require('./agent-schedule-view.html').default,
    controller: AgentScheduleViewCtrl
  });
